import HTTP from "../../http";

const PAYMENT_ENDPOINT = "/orders";
const PAYMENT_INTENT_ENDPOINT = "/secret/";

export async function getPaymentIntent(orderId) {
  return await HTTP.get(PAYMENT_ENDPOINT + PAYMENT_INTENT_ENDPOINT + orderId, {
    headers: { "Content-Type": "application/json" }
  });
}
